import { jsxs as G, jsx as B } from "react/jsx-runtime";
import { forwardRef as M, useRef as P, useImperativeHandle as W, useCallback as w, useLayoutEffect as L } from "react";
import { c as U } from "./cn-DlLpp5ix.js";
const Y = {
  sm: "px-2.5 py-2 text-sm",
  md: "px-3 py-2.5 text-sm",
  lg: "px-3.5 py-3 text-md"
}, Z = {
  base: "bg-bg-base",
  elevated: "bg-bg-elevated"
}, K = M(function({
  size: n = "md",
  surface: C = "base",
  invalid: S,
  rows: a = 4,
  minRows: c,
  maxRows: l = 12,
  autoResize: t = !1,
  monospace: j = !1,
  counter: f,
  className: E,
  disabled: m,
  readOnly: p,
  ["aria-invalid"]: b,
  onChange: u,
  value: x,
  defaultValue: g,
  ...F
}, I) {
  const d = P(null);
  W(
    I,
    () => d.current,
    []
  );
  const h = S ?? (b === !0 || b === "true"), s = w(() => {
    const e = d.current;
    if (!e || !t) return;
    e.style.height = "auto";
    const o = window.getComputedStyle(e), v = r(o.lineHeight) ?? r(o.fontSize) ?? 20, y = r(o.paddingTop) ?? 0, H = r(o.paddingBottom) ?? 0, T = r(o.borderTopWidth) ?? 0, N = r(o.borderBottomWidth) ?? 0, A = (c ?? a) * v + y + H + T + N, _ = l * v + y + H + T + N, D = Math.min(Math.max(e.scrollHeight, A), _);
    e.style.height = `${D}px`, e.style.overflowY = e.scrollHeight > _ ? "auto" : "hidden";
  }, [t, a, c, l]);
  L(() => {
    t && s();
  }, [t, s, x, g]);
  const k = w(
    (e) => {
      u?.(e), t && s();
    },
    [u, t, s]
  );
  return /* @__PURE__ */ G("div", { className: "flex flex-col gap-1", children: [
    /* @__PURE__ */ B(
      "textarea",
      {
        ref: d,
        rows: a,
        disabled: m,
        readOnly: p,
        "aria-invalid": h || void 0,
        onChange: k,
        value: x,
        defaultValue: g,
        className: U(
          "block w-full rounded-lg border outline-none transition-colors",
          "placeholder:text-tertiary text-primary",
          Y[n],
          Z[C],
          j ? "font-mono" : "font-sans",
          t ? "resize-none" : "resize-y",
          h ? "border-error-border focus-visible:border-error focus-visible:shadow-[0_0_0_3px_var(--error-bg)]" : "border-default hover:border-strong focus-visible:border-accent focus-visible:shadow-ring-focus",
          m ? "cursor-not-allowed opacity-60" : "",
          p ? "cursor-default" : "",
          E
        ),
        ...F
      }
    ),
    f ? /* @__PURE__ */ B("div", { className: "flex justify-end text-xs text-tertiary", children: f }) : null
  ] });
});
function r(i) {
  if (!i) return;
  const n = Number.parseFloat(i);
  return Number.isFinite(n) ? n : void 0;
}
export {
  K as T
};
//# sourceMappingURL=Textarea-DQs10nOW.js.map
